import { sendPost } from '@utils/request';

// 个人中心的地址接口
export function fetchAddressList(data) {
  const url = '/address/userNewAddressContract/queryUserAddressList';
  return sendPost({ url, data });
}

export function fetchAddressUpdate(data) {
  const url = '/address/userNewAddressContract/update';
  return sendPost({ url, data, specielApi: true });
}

export function fetchAddressCreate(data) {
  const url = '/address/userNewAddressContract/creat';
  return sendPost({ url, data, specielApi: true });
}

export function fetchAddressDelete(data) {
  const url = '/address/userNewAddressContract/deleteUserAddress';
  return sendPost({ url, data, specielApi: true });
}

// 修改运单配送地址
export function fetchUpdateAddressDelivery(data) {
  const url = '/tradeDeliveryOrderAddress/updateOrderAddressInfo';
  return sendPost({
    url,
    data,
    method: 'POST',
    baseURL: true,
    applicationType: true,
    deleteFalsyProp: true,
    Business: true,
    specielApi: true,
  });
}

// 查询地址是否在疫区
export function fetchAddressAreaLimit(data) {
  const url = '/trade/special/arealimit';
  return sendPost({ url, data });
}

// 获取全国各省数据
export function getProvince(data) {
  const url = '/trade/addressContract/getAllDistrict';
  return sendPost({ url, data });
}

// 获取某一省各城市数据
export function getCitiesByProvince(data) {
  const url = '/trade/addressContract/getAllCityByProvince';
  return sendPost({ url, data });
}

// 获取某省某市下的所有区县
export function getRegionsByCity(data) {
  const url = '/trade/addressContract/getAllRegionByCity';
  return sendPost({ url, data });
}

// 获取某省某市某区县下的所有街道
export function getStreetByRegion(data) {
  const url = '/trade/addressContract/getAllStreetByRegion';
  return sendPost({ url, data });
}
